<template>
  <layout>
    <div slot="content">
      <i-card :title="this.$route.meta.title">
        <div slot="content">
          <div>
            <el-form :inline="true" size="small">
              <el-form-item label="订单号">
                <el-input placeholder="订单号" v-model="filter.uuid" clearable></el-input>
              </el-form-item>
              <el-form-item label="商品名称">
                <el-select placeholder="商品名称" style="width: 175px" v-model="filter.product_id" clearable>
                  <el-option v-for="product in productList" :label="product.title" :value="product.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="filter.goods_type === 11" label="航班号">
                <el-input placeholder="航班号" v-model="filter.sailings_code" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系人手机号">
                <el-input v-model="filter.linker_mobile" placeholder="联系人手机号" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系人姓名">
                <el-input v-model="filter.linker_name" placeholder="联系人姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="出行日期">
                <el-date-picker  type="daterange"
                                 range-separator="至"
                                 start-placeholder="开始日期"
                                 end-placeholder="结束日期" v-model="filter.use_date" style="width: 380px" value-format="yyyy-MM-dd"
                                placeholder="出行日期" clearable></el-date-picker>
              </el-form-item>
              <el-form-item label="支付状态">
                <el-select placeholder="支付状态" style="width: 175px" v-model="filter.pay_status" clearable>
                  <el-option label="未支付" value="0"></el-option>
                  <el-option label="已支付" value="1"></el-option>
                  <el-option label="退款中" value="2"></el-option>
                  <el-option label="已退款" value="3"></el-option>
                  <el-option label="拒绝退款" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="处理状态">
                <el-select placeholder="处理状态" style="width: 175px" v-model="filter.resolve_status" clearable>
                  <el-option label="已处理" value="1"></el-option>
                  <el-option label="未处理" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单平台">
                <el-select placeholder="订单平台" style="width: 175px" v-model="filter.platform" clearable>
                  <el-option label="微信" value="1"></el-option>
                  <el-option label="支付宝" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单来源">
                <el-select filterable  placeholder="订单来源" style="width: 200px" v-model="filter.app_id" clearable>
                  <el-option v-for="app in appOptions" :label="app.label+ '('+ app.platform_name +')'" :value="app.value" />
                </el-select>
              </el-form-item>
            </el-form>
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-button type="primary" @click="getOrder(1)">查找</el-button>
                <el-button type="primary" @click="exportData()">导出</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>出行人数：{{peopleCount}} 人</div>
          <div style="overflow-x: auto;padding-bottom: 20px;" v-loading="loading">
            <div class="no-data" v-if="orderList.length <= 0">暂无订单</div>
            <div class="table-card" v-for="item in orderList">
              <div class="order-info" :style="item.people.length > 0?'border-bottom:0':''">
                <div class="order-item" style="width: 100%">
                  商品名称:{{ item.title }}(<strong>{{ item.goods_type }}</strong>)
                </div>
                <div class="order-item">
                  订单来源:{{ item.app_name }}--{{ item.app_platform_name }}
                </div>
                <div class="order-item">
                  平台来源:
                  <strong :style="{color: item.app_platform_name === '微信' ? '#07c160' : '#1677ff'}">
                    <i :class="item.app_platform_name === '微信' ? 'el-icon-postcard' : 'el-icon-wallet'" style="margin-right: 3px;"></i>
                    {{ item.app_platform_name || '未知' }}
                  </strong>
                </div>
                <div class="order-item">
                  航班号:{{ item.ship ? item.ship.sailings_code : '该订单无航班' }}
                </div>
                <div class="order-item">
                  联系人:{{ item.linker_name }}
                </div>
                <div class="order-item">
                  联系人手机:{{ item.linker_mobile }}
                </div>
                <div class="order-item">
                  出行日期:{{ item.use_date }}
                </div>
                <div class="order-item">
                  订单号:{{ item.uuid }}
                </div>
                <div class="order-item">
                  下单时间:{{ item.created_at }}
                </div>
                <div class="order-item">
                  购买数量:{{ item.goods_count }}张
                </div>
                <div class="order-item">
                  登船口:{{ item.ship ? (item.ship.enter_no || '未填写') : '该订单无航班' }}
                </div>
                <div class="order-item">
                  票券:{{ item.sku_title }}
                </div>
                <div class="order-item">
                  订单金额:{{ item.total }}元
                </div>
                <div class="order-item">
                  支付金额:{{ item.pay_total }}元
                </div>
                <div class="order-item">
                  订单类型:
                  <el-tag size="mini" type="warning">
                    {{ item.distribution.length > 0 ? '分销订单' : '普通订单' }}
                  </el-tag>
                </div>
                <div class="order-item">
                  支付状态:
                  <el-tag size="mini" :type="item.pay_status === 1?'success':'danger'">
                    {{ item.pay_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  出票状态:
                  <el-tag size="mini" :type="item.check_status === 2?'success':'danger'">
                    {{ item.check_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  处理状态:
                  <el-tag size="mini" :type="item.resolve_status === 1?'success':'danger'">
                    {{ item.resolve_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  支付商户:{{ item.mch_name }}({{ item.mch_id }})
                </div>
                <div class="order-item" style="width:100%;text-align: right;padding: 10px;">
                  <el-button size="mini" type="primary" @click="doShowDetails(item.uuid)">详情/编辑</el-button>
                  <el-tooltip
                    :content="item.contract_template_id > 0 ? '查看该订单合同' : '该产品未绑定合同模板'"
                    placement="top"
                    :disabled="item.pay_status !== 1 || item.contract_template_id > 0"
                  >
                    <span>
                      <el-button
                        size="mini"
                        type="warning"
                        @click="viewContract(item.uuid)"
                        :disabled="item.pay_status !== 1 || !item.contract_template_id"
                      >查看合同</el-button>
                    </span>
                  </el-tooltip>
                  <el-button size="mini" type="success" @click="copyOrderBaseInfo(item)">复制订单信息</el-button>
                  <el-button size="mini" type="success" @click="copyPeople(item.people,item)">复制游客信息</el-button>
                  <el-button size="mini" type="success" @click="showResolveConfirm(item.uuid)">标记处理</el-button>
                  <el-button size="mini" type="success" @click="showRefund(item.uuid)">申请退款</el-button>
                  <el-button size="mini" type="success" @click="showCheckConfirm(item.uuid)">出票</el-button>
                </div>
              </div>
              <table class="table">
                <tr v-for="people in item.people">
                  <td width="20%">{{ people.name }}</td>
                  <td width="20%">{{ maskIdCard(people.cert_no,people.cert_type) }}</td>
                  <td width="10%">{{ people.cert_type }}</td>
                  <td width="10%">{{people.price }} <template v-if="people.age_discount_rule.title">({{ people.age_discount_rule.title }})</template></td>
                  <td width="10%">{{ people.mobile }}</td>
                  <td width="10%">{{ people.age }}</td>
<!--                  <td width="20%">-->
<!--                    <el-radio @input="chooseSupplier(people.id,'')" v-model="people.supplier" label="">无</el-radio>-->
<!--                    <el-radio @input="chooseSupplier(people.id,'XA')" v-model="people.supplier" label="XA">XA</el-radio>-->
<!--                    <el-radio @input="chooseSupplier(people.id,'XF')" v-model="people.supplier" label="XF">XF</el-radio>-->
<!--                  </td>-->
                  <td width="20%">备注:
                    <el-input style="width: 80%" v-model="people.remark" size="mini" placeholder="请输入备注"
                              @blur="addRemark(people.id,people.remark)"></el-input>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="page-wrap">
            <el-pagination background :page-size="15" :current-page="pageInfo.current_page" layout="prev, pager, next"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--订单详情-->
      <el-drawer size="800" @close="closeOrder" :withHeader="false" :modal-append-to-body="true" :append-to-body="true"
                 custom-class="scroll" :visible.sync="showDetails">
        <orderDetails :uuid="currUuid"/>
      </el-drawer>
      <!--赠品列表-->
      <el-dialog title="处理订单" :visible.sync="resolveOrderDialog" width="40%">
        <div>确认是否已经处理完该订单？</div>
        <div style="font-size: 13px;margin: 10px 0;font-weight: bold">如有赠品，勾选后即可赠送</div>
        <div style="margin-bottom: 10px">
          <el-radio v-model="currSolveOrder.gift" label="">
          <span style="font-size: 13px;">
           无赠品
          </span>
          </el-radio>
        </div>
        <div v-for="(item,key) in giftList" style="margin-bottom: 10px;">
          <el-radio v-model="currSolveOrder.gift" :label="key">
          <span style="font-size: 13px;">
            产品:{{ item.scenic_name }} 票券:{{ item.ticket_name }}
          </span>
          </el-radio>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resolveOrderDialog = false">取 消</el-button>
          <el-button type="primary" @click="resolveOrder" :loading="resolveLoading">确 定</el-button>
        </div>
      </el-dialog>
      <!--申请退款-->
      <el-dialog title="申请退款" :visible.sync="refund.showDialog" width="40%">
        <el-form ref="form" label-width="80px">
          <el-form-item required label="退款原因">
            <el-input v-model="refund.reason" placeholder="请输入退款原因"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="refund.showDialog = false">取 消</el-button>
          <el-button type="primary" @click="doRefund" :loading="refund.refundLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import orderDetails from "@/pages/order/order-detail-left"
import {id} from "html-webpack-plugin/lib/chunksorter";
import OrderReminderService from '@/services/orderReminderService'

export default {
  components: {
    orderDetails
  },
  name: "order-list",
  data() {
    return {
      orderList: [],
      showDetails: false,
      currUuid: "",
      filter: {
        linker_mobile: '',
        pay_status: '',
        uuid: '',
        goods_type: '',
        resolve_status: '',
        title: '',
        sailings_code: '',
        platform: '',
        app_id: '',
        product_id: '',
      },
      loading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
      },
      giftList: [],
      appOptions: [],
      resolveOrderDialog: false,
      resolveLoading: false,
      currSolveOrder: {
        uuid: "",
        gift: "",
      },
      refund: {
        showDialog: false,
        reason: "",
        orderUuid: "",
        refundLoading: false
      },
      balance:0,
      productList:[],
      peopleCount: 0,
    }
  },
  methods: {
    getOrder: function (page = '', needScroll = true, isExport = false) {
      if (needScroll) {
        this.loading = true;
      }
      if (page) {
        this.pageInfo.current_page = page;
      }
      this.$http.request('orderList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
        if (needScroll) {
          window.scrollTo(0, 0)
        }
      });
      this.getPeopleCount();
    },
    getBalance:function (){
      this.$http.request("opWalletBalance").then(res => {
        this.balance = res.data.balance;
      });
    },

    exportData: function () {
      const url = this.$http.request('exportOrder', {
        filter: this.filter,
        hash: Math.random() * 1000,
      }, true);
      window.open(url)
    },
    getPeopleCount: function () {
      this.$http.request('getPeopleCount', {
        filter: this.filter,
      }).then(res=>{
        this.peopleCount = res.data.people_count;
      });
    },
    getGiftList: function () {
      this.$http.request('giftList').then(res => {
        this.giftList = res.data;
      })
    },
    getAppOptions: function () {
      this.$http.request('appListOptions').then(res => {
        this.appOptions = res.data;
      })
    },
    closeOrder: function () {
      this.$http.request('orderList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.pageInfo = res.meta;
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getOrder();
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = '';
        }
      }
      this.getOrder();
    },
    showCheckConfirm: function (uuid) {
      this.$confirm('确定要出票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkOut(uuid);
      });
    },
    showResolveConfirm: function (uuid) {
      this.resolveOrderDialog = true;
      this.currSolveOrder.uuid = uuid;
      this.currSolveOrder.gift = "";
    },
    resolveOrder: function () {
      this.resolveLoading = true;
      this.$http.request('resolveOrder', this.currSolveOrder).then(res => {
        this.resolveLoading = false;
        if (res.status === 'success') {
          this.resolveOrderDialog = false;
          this.getOrder('', false);
        }
      }).catch(() => {
        this.resolveLoading = false;
      })
    },
    showRefund: function (uuid) {
      this.refund.showDialog = true;
      this.refund.orderUuid = uuid;
      this.refund.reason = "";
    },
    //退款
    doRefund: function () {
      this.refund.refundLoading = true;
      this.$http.request('createRefund', {order_uuid: this.refund.orderUuid, reason: this.refund.reason}).then(res => {
        this.refund.refundLoading = false;
        if (res.status === 'success') {
          this.refund.showDialog = false;
          this.getOrder('', false);
          this.$message({message: res.message, type: "success"});
        }
      }).catch(res => {
        this.refund.refundLoading = false;
      })
    },
    checkOut: function (uuid) {
      this.$http.request('checkOrder', {uuid: uuid}).then(res => {
        if (res.status === 'success') {
          this.getOrder('', false);
        }
      });
    },
    addRemark: function (id, remark) {
      this.$http.request('addPeopleRemark', {id: id, remark: remark}).then(res => {
        this.$notify({
          title: '成功',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    },
    copyOrderBaseInfo: function (order) {
      let content = "";
      content += "联系人:" + order.linker_name + "\n";
      content += "联系人手机:" + order.linker_mobile + "\n";
      content += "出行日期:" + order.use_date + "\n";
      if (order.ship) {
        content += "航班号:" + order.ship.sailings_code + "\n";
        content += "开船时间:" + order.ship.start_time + "\n";
        content += "人数:" + order.goods_count + "\n";
        content += order.ship.start_wharf + '-' + order.ship.end_wharf + "\n";
      }

      let aux = document.createElement("textarea");
      aux.value = content;
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message({message: "复制成功!", type: "success"});
      this.$http.request('copyPeopleLog',{order_uuid:order.uuid,copy_content:content});
    },
    copyPeople: function (people, order) {
      this.getBalance();
      if(this.balance < -1000){
        this.$confirm('运营豆余额不足，请充值后再试。');
        return false;
      }
      let content = "";
      content += "出行日期:" + order.use_date + "\n\n";
      if (order.ship) {
        content += "航班号:" + order.ship.sailings_code + "\n";
      }
      people.forEach(row => {
        content += row.name + " " + row.cert_no + " \n"
      })
      content += '\n联系人手机:' +order.linker_mobile
      let aux = document.createElement("textarea");
      aux.value = content;
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message({message: "复制成功!", type: "success"});
      this.$http.request('copyPeopleLog',{order_uuid:order.uuid,copy_content:content});
    },
    doShowDetails: function (uuid) {
      this.currUuid = uuid;
      this.showDetails = true;
    },
    viewContract: function (uuid) {
      const routeData = this.$router.resolve({
        path: '/contract/preview',
        query: { orderUuid: uuid }
      });
      window.open(routeData.href, '_blank');
    },
    chooseSupplier: function (id, supplier) {
      this.$http.request('editPeopleSupplier', {id, supplier}).then(res => {
        console.log(res)
      })
    },
    maskIdCard:function (idNumber,certType){
      if(certType !== '身份证'){
        return idNumber;
      }
      const start = idNumber.slice(0, 6);
      const end = idNumber.slice(15);
      const hiddenPart = "*******";
      return start + hiddenPart + end;
    },
    maskPhone:function (phone){
      const start = phone.slice(0, 3);
      const end = phone.slice(7);
      const hiddenPart = "****";
      return start + hiddenPart + end;
    },
    getProductList:function (){
      let _self = this;
      this.$http.request('productList', {type: this.$route.meta.goodsType}).then((res) => {
        _self.productList = res.data;
      });
    },
    
    /**
     * 初始化订单提醒服务
     */
    initializeOrderReminder: function () {
      // 如果订单提醒已启用，则启动服务
      if (this.$store.getters.orderReminder.enabled) {
        OrderReminderService.startReminder();
      }
    }
  },
  created: function () {
    this.getOrder();
    this.getGiftList();
    this.getAppOptions();
    this.getBalance();
    this.getProductList();
    this.filter['goods_type'] = this.$route.meta.goodsType;
    
    // 初始化订单提醒服务
    this.initializeOrderReminder();
  },
  
  beforeDestroy: function () {
    // 组件销毁时清理订单提醒服务
    OrderReminderService.stopReminder();
  },
  watch: {
    '$route': function () {
      this.filter['goods_type'] = this.$route.meta.goodsType;
      this.getProductList();
      this.getOrder();
    }
  }
}
</script>

<style scoped>

.table-card {
  width: 100%;
  font-size: 12px;
  margin-top: 30px;
}

.table-card .order-info {
  background: #f9f9f9;
  overflow: hidden;
  border: 1px solid #dcdcdc;
}

.table-card .order-info .order-item {
  float: left;
  width: 25%;
  padding: 5px 10px;
  box-sizing: border-box;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table tr:hover {
  background: #eee;
}

.table td {
  border: 1px solid #dcdcdc;
  padding: 10px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 30px;
}

.remark {
  cursor: pointer;
  padding: 3px 10px;
}

.remark:hover {
  box-shadow: 2px 2px 8px #888;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order-list.vue